var React = require('react');

function ErrorIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#tcljezap1a)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm1 11H7v2h2v-2zm0-8H7v7h2V3z","fill":"#FF3B3B"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"tcljezap1a"},React.createElement("path",{"fill":"#fff","d":"M0 0h16v16H0z"})))]);
}

ErrorIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ErrorIcon;

ErrorIcon.default = ErrorIcon;
